/* MolCellQuest 問題データ — 細胞骨格・接着・細胞運動
   ★ 配列に追記すればそのまま反映されます（id は全体で一意に）。
   ★ diff : 80〜320。基礎 0-179 / 標準 180-269 / 応用 270+ */

const CAT = { track: "cell", category: "dynamics", categoryName: "細胞骨格・接着・細胞運動" };

export const CELL_DYNAMICS = [
  {
    id: "dyn01", ...CAT,
    title: "細胞骨格の3種類", diff: 95, tags: ["微小管", "アクチン", "中間径フィラメント"],
    explain: `<p>真核細胞の細胞骨格と、その構成タンパク質の組み合わせとして<b>誤っている</b>ものはどれか。</p>`,
    type: "radio",
    options: [
      "微小管 — チューブリン",
      "アクチンフィラメント（微小繊維） — アクチン",
      "中間径フィラメント — ケラチン、ラミンなど",
      "微小管 — ミオシン",
    ],
    answer: 3,
    hints: ["ミオシンは「フィラメントそのもの」でしょうか、それとも「その上を動くもの」でしょうか。", "微小管を構成するのはα・βチューブリンの二量体です。"],
    solution: `<p><b>【ステップ1】3種の細胞骨格</b></p>
               <table>
                 <tr><th></th><th>太さ</th><th>構成単位</th><th>主な役割</th><th>モーター</th></tr>
                 <tr><td>微小管</td><td>25 nm</td><td>α/βチューブリン二量体</td><td>紡錘体、細胞内輸送、繊毛・鞭毛</td><td>キネシン、ダイニン</td></tr>
                 <tr><td>アクチンフィラメント</td><td>7 nm</td><td>アクチン</td><td>細胞の形、収縮環、葉状仮足</td><td>ミオシン</td></tr>
                 <tr><td>中間径フィラメント</td><td>10 nm</td><td>ケラチン、ビメンチン、ラミン等</td><td>機械的強度</td><td>なし</td></tr>
               </table>
               <p><b>【ステップ2】ミオシンの位置づけ</b></p>
               <p>ミオシンは細胞骨格の構成要素ではなく、
               <b>アクチンフィラメントの上を滑る モータータンパク質</b>です。
               筋収縮も細胞質分裂の収縮環も、この滑りで起こります。</p>
               <p><b>【ステップ3】中間径フィラメントの特異性</b></p>
               <p>3種のうち中間径フィラメントだけが<b>極性を持たず、モーターも持ちません</b>。
               その代わり最も引っ張りに強く、細胞に機械的な耐久性を与えます。
               核膜の内側を裏打ちするラミンもこの仲間で、
               ラミンの変異は早老症（ハッチンソン・ギルフォード症候群）を引き起こします。</p>
               <p>したがって、誤っているのは <b>D</b> です。</p>`,
  },

  {
    id: "dyn02", ...CAT,
    title: "モータータンパク質の進む向き", diff: 140, tags: ["キネシン", "ダイニン", "微小管の極性"],
    explain: `<p>微小管には極性があり、中心体側が <b>マイナス端</b>、細胞辺縁側が <b>プラス端</b> である。</p>
              <p>モータータンパク質の進む向きの組み合わせとして正しいものはどれか。</p>`,
    type: "radio",
    options: [
      "キネシン：プラス端へ ／ ダイニン：マイナス端へ",
      "キネシン：マイナス端へ ／ ダイニン：プラス端へ",
      "どちらもプラス端へ",
      "どちらもマイナス端へ",
    ],
    answer: 0,
    hints: [
      "神経細胞の軸索輸送を思い出しましょう。細胞体から末端へ運ぶのがどちらでしょうか。",
      "「キネシンは外向き（順行性）、ダイニンは内向き（逆行性）」と覚えます。",
    ],
    solution: `<p><b>【ステップ1】2つのモーターの向き</b></p>
               <ul>
                 <li><b>キネシン</b>：<b>プラス端</b>へ（細胞の外側・末梢へ）</li>
                 <li><b>ダイニン</b>：<b>マイナス端</b>へ（中心体・核の方へ）</li>
               </ul>
               <p><b>【ステップ2】神経細胞で覚える</b></p>
               <p>軸索の微小管はプラス端が末端を向いています。</p>
               <table>
                 <tr><th>輸送</th><th>向き</th><th>モーター</th><th>運ぶもの</th></tr>
                 <tr><td>順行性</td><td>細胞体 → 軸索末端</td><td><b>キネシン</b></td><td>新しいシナプス小胞、ミトコンドリア</td></tr>
                 <tr><td>逆行性</td><td>軸索末端 → 細胞体</td><td><b>ダイニン</b></td><td>老廃物、神経栄養因子のシグナル</td></tr>
               </table>
               <p><b>【ステップ3】応用</b></p>
               <p>この一方通行の性質は病原体にも利用されています。
               狂犬病ウイルスや破傷風毒素は、末端から取り込まれたあと
               <b>ダイニンに乗って</b>中枢神経へ運ばれます。</p>
               <p>また細胞分裂時、ダイニンが紡錘体極へ向かう力を出し、
               キネシンが極どうしを押し離すことで、紡錘体の形が保たれます。</p>
               <p>したがって、正解は <b>A</b> です。</p>`,
  },

  {
    id: "dyn03", ...CAT,
    title: "細胞接着装置", diff: 160, tags: ["デスモソーム", "タイト結合", "ギャップ結合"],
    explain: `<p>上皮細胞どうしをつなぐ結合と、その働きの組み合わせとして<b>誤っている</b>ものはどれか。</p>`,
    type: "radio",
    options: [
      "密着結合（タイト結合） — 細胞間の隙間をふさぎ、物質の自由な通過を防ぐ",
      "接着結合 — カドヘリンを介してアクチンフィラメントどうしをつなぐ",
      "デスモソーム — カドヘリンを介して中間径フィラメントどうしをつなぐ",
      "ギャップ結合 — 細胞どうしを機械的に強く固定する",
    ],
    answer: 3,
    hints: [
      "ギャップ結合は「つなぎとめる」ためのものでしょうか、それとも「やりとりする」ためのものでしょうか。",
      "コネキシンが作る孔（コネクソン）を通るのは何でしょう。",
    ],
    solution: `<p><b>【ステップ1】4種の結合を整理する</b></p>
               <table>
                 <tr><th>結合</th><th>主なタンパク質</th><th>つながる骨格</th><th>働き</th></tr>
                 <tr><td>密着結合</td><td>クローディン、オクルディン</td><td>—</td><td>細胞間隙の封鎖、膜タンパク質の局在維持</td></tr>
                 <tr><td>接着結合</td><td>Eカドヘリン</td><td>アクチン</td><td>細胞どうしの接着</td></tr>
                 <tr><td>デスモソーム</td><td>デスモグレイン等</td><td>中間径フィラメント</td><td>強い機械的接着</td></tr>
                 <tr><td><b>ギャップ結合</b></td><td>コネキシン</td><td>—</td><td><b>小分子・イオンの直接通過（連絡）</b></td></tr>
               </table>
               <p><b>【ステップ2】ギャップ結合は「接着」ではない</b></p>
               <p>名前に「結合」とありますが、機械的に固定するのが仕事ではありません。
               6個のコネキシンが集まって <b>コネクソン</b> という孔を作り、
               隣り合う細胞のコネクソンとドッキングして<b>細胞質どうしを直接つなぐ通路</b>になります。
               分子量 1000 程度までのイオン・cAMP・Ca²⁺ などが通れます。</p>
               <p><b>【ステップ3】その意義</b></p>
               <p>心筋では活動電位がギャップ結合を通じて瞬時に伝わり、
               細胞群が<b>一斉に収縮</b>できます。ギャップ結合がなければ、
               心臓は同期して拍動できません。</p>
               <p class="tiny">なお密着結合の重要性は、腸管や血液脳関門を思えば分かります。
               ここが壊れると、細胞の「あいだ」を通って物質が素通りしてしまいます。</p>
               <p>したがって、誤っているのは <b>D</b> です。</p>`,
  },

  {
    id: "dyn04", ...CAT,
    title: "アクチンの重合と細胞運動", diff: 185, tags: ["トレッドミリング", "葉状仮足", "細胞遊走"],
    explain: `<p>細胞が這うように移動するとき、進行方向の先端では何が起きているか。
              最も適切なものはどれか。</p>`,
    type: "radio",
    options: [
      "アクチンフィラメントのプラス端で重合が進み、膜を押し出して葉状仮足を作る。",
      "ミオシンが微小管の上を滑り、膜を引っ張る。",
      "中間径フィラメントが伸長して膜を押し出す。",
      "微小管がマイナス端で脱重合し、細胞を引き寄せる。",
    ],
    answer: 0,
    hints: [
      "葉状仮足（ラメリポディア）の中身は、どの細胞骨格が密に詰まっているでしょうか。",
      "重合そのものが力を生みます。伸びるフィラメントが膜を内側から押します。",
    ],
    solution: `<p><b>【ステップ1】細胞遊走の4段階</b></p>
               <ol>
                 <li><b>突出</b>：先端でアクチンが重合し、葉状仮足・糸状仮足を押し出す</li>
                 <li><b>接着</b>：インテグリンが細胞外基質に結合し、接着斑を作る</li>
                 <li><b>収縮</b>：アクチン－ミオシンの収縮力で細胞体を前へ引く</li>
                 <li><b>脱接着</b>：後端の接着を外す</li>
               </ol>
               <p><b>【ステップ2】重合が力になる仕組み</b></p>
               <p>アクチンフィラメントは<b>プラス端（バーブド端）で重合し、
               マイナス端（ポインテッド端）で脱重合</b>します。
               正味の長さが変わらないまま単量体が流れていく状態を
               <b>トレッドミリング</b>と呼びます。</p>
               <p>先端では <b>Arp2/3複合体</b> が既存のフィラメントの側面から
               70度の角度で新しい枝を出し、樹状の網目を作ります。
               この網目がプラス端を膜に向けて伸びることで、
               <b>重合の力そのものが膜を押し出します</b>。モーターは要りません。</p>
               <p><b>【ステップ3】他の選択肢を退ける</b></p>
               <ul>
                 <li>B ⇒ ミオシンが滑るのは<b>アクチン</b>の上です（微小管ではありません）。
                     なお細胞体を引き寄せる収縮には、確かにミオシンIIが働きます。</li>
                 <li>C ⇒ 中間径フィラメントは極性も動的な伸長性も持ちません。</li>
                 <li>D ⇒ 微小管は遊走の方向決めには関わりますが、先端の押し出しはアクチンの仕事です。</li>
               </ul>
               <p class="tiny">がん細胞の浸潤・転移もこの機構を使っており、
               Rho ファミリー低分子量Gタンパク質（Rac, Cdc42, Rho）がその制御を担っています。</p>
               <p>したがって、正解は <b>A</b> です。</p>`,
  },

  {
    id: "dyn05", ...CAT,
    title: "繊毛・鞭毛の 9+2 構造", diff: 210, tags: ["軸糸", "ダイニン", "繊毛"],
    explain: `<p>真核生物の運動性繊毛・鞭毛の軸糸は「9+2 構造」をとる。</p>
              <p>その運動の仕組みとして正しいものはどれか。</p>`,
    type: "radio",
    options: [
      "微小管が伸び縮みすることで屈曲する。",
      "隣り合う微小管二重管のあいだで、ダイニンが滑りを生み、ネキシンによる架橋がそれを屈曲に変える。",
      "アクチンとミオシンの滑りによって屈曲する。",
      "中心の2本の微小管が回転することで、全体がねじれる。",
    ],
    answer: 1,
    hints: [
      "もし微小管どうしが自由に滑れるだけなら、繊毛はどうなってしまうでしょうか。",
      "「滑り」を「曲がり」に変換するには、滑りを制限する何かが要ります。",
    ],
    solution: `<p><b>【ステップ1】9+2 構造とは</b></p>
               <p>外側に微小管の<b>二重管が9組</b>、中心に<b>単管が2本</b>という配置です
               （基部の基底小体は 9+0 の三重管）。</p>
               <p><b>【ステップ2】滑りを屈曲に変える</b></p>
               <ol>
                 <li>二重管から伸びる<b>ダイニン腕</b>が、隣の二重管をつかんでマイナス端方向へ動かす</li>
                 <li>そのままなら二重管どうしが<b>ずるずる滑って伸びていくだけ</b>になる</li>
                 <li>しかし <b>ネキシン</b> が二重管どうしを架橋し、滑りを制限している</li>
                 <li>その結果、滑ろうとする力が<b>屈曲</b>に変換される</li>
               </ol>
               <p>実際、単離した軸糸をプロテアーゼで処理してネキシンを壊すと、
               ATP を加えたときに<b>曲がらずに滑って伸びてしまいます</b>。
               この実験が「拘束があるから曲がる」ことを直接示しました。</p>
               <p><b>【ステップ3】臨床との接続</b></p>
               <p>ダイニン腕の欠損は<b>原発性繊毛運動不全症</b>を起こします。
               気道の繊毛が動かず慢性気道感染、精子が泳げず不妊、
               さらに発生初期のノード繊毛が働かないため<b>内臓逆位</b>が約半数に生じます
               （カルタゲナー症候群）。1つのモーターの欠損が、
               これほど離れた症状を同時に説明できるのが面白いところです。</p>
               <p>したがって、正解は <b>B</b> です。</p>`,
  },

  {
    id: "dyn06", ...CAT,
    title: "上皮間葉転換（EMT）", diff: 255, tags: ["EMT", "Eカドヘリン", "転移"],
    explain: `<p>上皮間葉転換（EMT）が起こるとき、細胞に見られる変化として<b>適切でない</b>ものはどれか。</p>`,
    type: "radio",
    options: [
      "Eカドヘリンの発現が低下する。",
      "細胞極性が失われ、移動能が高まる。",
      "ビメンチンなど間葉系マーカーの発現が上がる。",
      "密着結合が強化され、細胞どうしがより強固に結合する。",
    ],
    answer: 3,
    hints: [
      "EMT は「動かない上皮細胞」が「動ける間葉系細胞」に変わる過程です。結合はどうなるべきでしょう。",
      "移動するためには、まず隣の細胞から離れなければなりません。",
    ],
    solution: `<p><b>【ステップ1】EMT とは何か</b></p>
               <p>敷石状に並んで動かない<b>上皮細胞</b>が、
               バラバラに動ける<b>間葉系細胞</b>の性質を獲得する過程です。</p>
               <table>
                 <tr><th></th><th>上皮</th><th>間葉</th></tr>
                 <tr><td>接着</td><td>強い（Eカドヘリン）</td><td>弱い（Nカドヘリンへ切り替え）</td></tr>
                 <tr><td>極性</td><td>頂端-基底の極性あり</td><td>失われる</td></tr>
                 <tr><td>中間径フィラメント</td><td>ケラチン</td><td>ビメンチン</td></tr>
                 <tr><td>運動性</td><td>低い</td><td><b>高い</b></td></tr>
               </table>
               <p><b>【ステップ2】D が誤りである理由</b></p>
               <p>動けるようになるには、まず<b>隣の細胞との結合を解く</b>必要があります。
               密着結合も接着結合も<b>弱まります</b>。強化されては動けません。</p>
               <p><b>【ステップ3】制御と意義</b></p>
               <p>EMT は Snail・Slug・Twist・ZEB といった転写因子によって駆動され、
               これらは <i>CDH1</i>（Eカドヘリン遺伝子）を直接抑制します。</p>
               <p>EMT は病的な現象ではなく、正常発生に必須です。</p>
               <ul>
                 <li>原腸形成での中胚葉細胞の移動</li>
                 <li>神経堤細胞が神経管から離れて全身へ移動する過程</li>
                 <li>創傷治癒</li>
               </ul>
               <p>問題は、がん細胞がこの発生プログラムを<b>再活性化</b>して
               浸潤・転移に使うことです。転移先では逆の MET が起こって定着します。</p>
               <p>したがって、適切でないのは <b>D</b> です。</p>`,
  },

  {
    id: "dyn07", ...CAT,
    title: "阻害剤から機構を推定する", diff: 235, tags: ["コルヒチン", "ファロイジン", "実験推論"],
    explain: `<p>培養細胞に薬剤を加えたところ、次の変化が見られた。</p>
              <ul>
                <li>薬剤 X：分裂期の細胞が中期で停止し、紡錘体が消失した</li>
                <li>薬剤 Y：細胞質分裂だけが失敗し、二核細胞が増えた。分裂期の進行は正常だった</li>
              </ul>
              <p>X と Y が作用している細胞骨格の組み合わせとして最も適切なものはどれか。</p>`,
    type: "radio",
    options: [
      "X：微小管 ／ Y：アクチンフィラメント",
      "X：アクチンフィラメント ／ Y：微小管",
      "X：中間径フィラメント ／ Y：微小管",
      "X：微小管 ／ Y：中間径フィラメント",
    ],
    answer: 0,
    hints: [
      "紡錘体を作っているのはどの細胞骨格でしょうか。",
      "細胞質分裂で細胞をくびり切る「収縮環」は何でできているでしょうか。",
    ],
    solution: `<p><b>【ステップ1】表現型から責任分子を絞る</b></p>
               <p><b>薬剤 X：紡錘体が消失し、中期で停止</b><br>
               紡錘体は<b>微小管</b>でできています。微小管が失われると
               染色体が赤道面に並べず、<b>紡錘体形成チェックポイント</b>が
               細胞周期を中期で止めます。コルヒチンやノコダゾール（重合阻害）、
               タキソール（脱重合阻害）が典型例です。</p>
               <p><b>薬剤 Y：分裂期は正常だが細胞質分裂だけ失敗</b><br>
               細胞質分裂は<b>アクチン－ミオシンII の収縮環</b>がくびり切ります。
               ここだけが壊れると、核分裂は完了するのに細胞が分かれず
               <b>二核細胞</b>が生じます。サイトカラシンD（重合阻害）が典型です。</p>
               <p><b>【ステップ2】推論の型を押さえる</b></p>
               <p>「どの段階で止まったか」から「どの構造が要るか」を逆算するのが、
               阻害剤実験の読み方です。</p>
               <table>
                 <tr><th>表現型</th><th>責任構造</th></tr>
                 <tr><td>中期で停止、紡錘体なし</td><td>微小管</td></tr>
                 <tr><td>二核細胞、収縮環なし</td><td>アクチン</td></tr>
                 <tr><td>細胞が機械的ストレスで壊れやすい</td><td>中間径フィラメント</td></tr>
               </table>
               <p><b>【ステップ3】臨床への接続</b></p>
               <p>微小管を標的とする薬（タキソール、ビンクリスチン）が抗がん剤として使われるのは、
               分裂の盛んな細胞ほど紡錘体に依存するからです。
               副作用として末梢神経障害が出るのは、
               神経の軸索輸送もまた微小管に依存しているためです。</p>
               <p>したがって、正解は <b>A</b> です。</p>`,
  },

  {
    id: "dyn08", ...CAT,
    title: "筋収縮の滑り説", diff: 165, tags: ["サルコメア", "滑り説", "筋収縮"],
    explain: `<p>骨格筋が収縮するとき、サルコメア（筋節）に起こる変化として正しいものはどれか。</p>`,
    type: "radio",
    options: [
      "アクチンフィラメントとミオシンフィラメントの両方が短くなる。",
      "フィラメントの長さは変わらず、重なり合いが増えてサルコメアが短くなる。",
      "サルコメアの長さは変わらず、フィラメントが太くなる。",
      "ミオシンフィラメントだけが短くなる。",
    ],
    answer: 1,
    hints: [
      "「滑り説」という名前がヒントです。何が何に対して滑るのでしょう。",
      "収縮時、A帯（ミオシンの長さ）は変わらず、I帯とH帯だけが狭くなります。",
    ],
    solution: `<p><b>【ステップ1】滑り説の要点</b></p>
               <p><b>フィラメント自体の長さは変わりません。</b>
               アクチンフィラメントがミオシンフィラメントのあいだへ<b>滑り込み</b>、
               重なりが増えることで Z 膜どうしが近づき、サルコメアが短くなります。</p>
               <p><b>【ステップ2】帯の変化で確かめる</b></p>
               <table>
                 <tr><th>部位</th><th>実体</th><th>収縮時</th></tr>
                 <tr><td>A帯</td><td>ミオシンフィラメントの長さ</td><td><b>不変</b></td></tr>
                 <tr><td>I帯</td><td>アクチンのみの領域</td><td>狭くなる</td></tr>
                 <tr><td>H帯</td><td>ミオシンのみの領域</td><td>狭くなる</td></tr>
               </table>
               <p><b>A帯が変わらない</b>という観察こそが、
               「ミオシンは短くなっていない」ことの直接の証拠です。
               ハクスリーらはこれを位相差顕微鏡で見て滑り説にたどり着きました。</p>
               <p><b>【ステップ3】力を生む仕組み</b></p>
               <ol>
                 <li>Ca²⁺ がトロポニンCに結合</li>
                 <li>トロポミオシンがずれ、アクチン上のミオシン結合部位が露出</li>
                 <li>ミオシン頭部が結合し、ADP と Pi を放して<b>首振り（パワーストローク）</b></li>
                 <li>新しい ATP が結合すると頭部が離れ、加水分解で再び立ち上がる</li>
               </ol>
               <p class="tiny">死後硬直は、ATP が枯渇して4のステップが起こらず、
               ミオシンがアクチンに結合したまま外れなくなるために生じます。
               「ATP は収縮ではなく<b>弛緩</b>に必要」という逆説的な事実です。</p>
               <p>したがって、正解は <b>B</b> です。</p>`,
  },

  {
    id: "dyn09", ...CAT,
    title: "細胞外基質とインテグリン", diff: 200, tags: ["インテグリン", "細胞外基質", "接着斑"],
    explain: `<p>細胞外基質（ECM）と細胞をつなぐインテグリンについて、<b>誤っている</b>記述はどれか。</p>`,
    type: "radio",
    options: [
      "αとβのサブユニットからなるヘテロ二量体である。",
      "細胞外でフィブロネクチンやコラーゲンに、細胞内でアクチン細胞骨格に（アダプターを介して）結合する。",
      "細胞外から細胞内へ情報を伝えるだけでなく、細胞内の状態が細胞外への結合力を変えることもある。",
      "インテグリンは基質に結合するだけの構造タンパク質で、シグナル伝達には関与しない。",
    ],
    answer: 3,
    hints: [
      "「接着斑」には FAK（接着斑キナーゼ）という酵素が集まります。何のためでしょう。",
      "細胞が「自分は足場に着いているか」を知らないと、どんな不都合があるでしょうか。",
    ],
    solution: `<p><b>【ステップ1】インテグリンの構造と橋渡し</b></p>
               <p>α・βのヘテロ二量体で、細胞膜を1回貫通します。</p>
               <ul>
                 <li><b>細胞外</b>：フィブロネクチン、ラミニン、コラーゲンなどの ECM に結合
                     （多くは RGD 配列を認識）</li>
                 <li><b>細胞内</b>：タリン、ビンキュリン、α-アクチニンを介して<b>アクチン</b>に結合</li>
               </ul>
               <p>つまり ECM と細胞骨格を機械的に連結する構造体です。</p>
               <p><b>【ステップ2】双方向のシグナル伝達</b></p>
               <p>インテグリンは単なる「留め具」ではありません。</p>
               <ul>
                 <li><b>アウトサイドイン</b>：ECM への結合が接着斑に FAK・Src を集め、
                     増殖・生存シグナルを起動する</li>
                 <li><b>インサイドアウト</b>：細胞内のタリン結合が構造変化を起こし、
                     ECM への<b>親和性そのものを変える</b>（血小板の活性化が典型例）</li>
               </ul>
               <p><b>【ステップ3】足場依存性とアノイキス</b></p>
               <p>正常な接着細胞は、足場に接着していないと
               <b>アノイキス</b>という特殊なアポトーシスで死にます。
               これは「本来の場所を離れた細胞を排除する」安全装置です。</p>
               <p>がん細胞がこの依存性を失う（足場非依存性増殖を獲得する）ことが、
               転移を可能にする重要な一歩になります。
               軟寒天コロニー形成能の試験は、まさにこの性質を測るものです。</p>
               <p>したがって、誤っているのは <b>D</b> です。</p>`,
  },

  {
    id: "dyn10", ...CAT,
    title: "核内ラミンと早老症", diff: 300, tags: ["ラミン", "核膜", "プロジェリア"],
    explain: `<p>ハッチンソン・ギルフォード早老症は、<i>LMNA</i> 遺伝子の変異により、
              ラミンA前駆体の C末端が正しく切断されず、
              <b>ファルネシル基が付いたまま</b>のタンパク質（プロジェリン）が蓄積することで起こる。</p>
              <p>この病態から導かれる推論として、最も適切なものはどれか。</p>`,
    type: "radio",
    options: [
      "ファルネシル基は水溶性を高めるため、プロジェリンが核質に拡散して核膜が薄くなる。",
      "ファルネシル基は脂質性で膜に留まり続けるため、プロジェリンが核膜に固定され、核の形態と力学的性質が異常になる。",
      "プロジェリンは細胞質へ運ばれ、アクチン細胞骨格を破壊する。",
      "ラミンは中間径フィラメントではないため、核の力学とは無関係である。",
    ],
    answer: 1,
    hints: [
      "ファルネシル基は炭素15個のイソプレノイド。水になじむでしょうか、脂質になじむでしょうか。",
      "正常なラミンAは、核膜に組み込まれたあとファルネシル基を切り離します。切れないとどうなるでしょう。",
    ],
    solution: `<p><b>【ステップ1】ファルネシル化の意味</b></p>
               <p>ファルネシル基は炭素15個の<b>疎水性</b>イソプレノイドで、
               タンパク質を<b>膜につなぎとめる錨</b>として働きます。</p>
               <p><b>【ステップ2】正常なラミンAの成熟</b></p>
               <ol>
                 <li>プレラミンA が合成され、C末端の CaaX モチーフがファルネシル化される</li>
                 <li>この脂質の錨で内核膜へ運ばれ、組み込まれる</li>
                 <li><b>ZMPSTE24 が C末端を切断し、ファルネシル基ごと外す</b></li>
                 <li>錨を失った成熟ラミンAが、核ラミナの網目に組み込まれる</li>
               </ol>
               <p><b>【ステップ3】プロジェリンでは何が起こるか</b></p>
               <p>変異により切断部位が失われるため、ステップ3が起こりません。
               ファルネシル基が付いたままのプロジェリンは
               <b>内核膜に貼りついたまま外れず</b>、正常なラミナ網目を作れません。</p>
               <p>結果として核は<b>いびつな分葉状</b>になり、
               クロマチン構造と機械的な強度が損なわれ、
               細胞は繰り返しの力学的ストレスに耐えられず早期老化を示します。</p>
               <p><b>【ステップ4】治療への応用</b></p>
               <p>この機構的理解から、<b>ファルネシル基転移酵素阻害剤（ロナファルニブ）</b>が
               治療薬として開発され、2020年に承認されました。
               「錨が付くのを最初から防ぐ」という発想です。<br>
               病態の分子機構を正確に押さえることが、そのまま創薬標的の同定につながった好例といえます。</p>
               <p><b>【他の選択肢】</b></p>
               <ul>
                 <li>A ⇒ ファルネシル基は疎水性で、水溶性を<b>下げます</b>。</li>
                 <li>C ⇒ プロジェリンは核内に留まります。</li>
                 <li>D ⇒ ラミンは<b>中間径フィラメントの一種</b>（V型）であり、核の力学の中心です。</li>
               </ul>
               <p>したがって、正解は <b>B</b> です。</p>`,
  },

  {
    id: "dyn11", ...CAT,
    title: "細胞外マトリックスの3分類", diff: 160, tags: ["ECM", "コラーゲン", "フィブロネクチン"],
    explain: `<p>細胞外マトリックス（ECM）の成分は、大きく3群に分けられる。</p>
              <p>分類とその代表例の組み合わせとして正しいものはどれか。</p>`,
    type: "radio",
    options: [
      "構造タンパク質＝コラーゲン・エラスチン／プロテオグリカン／接着性糖タンパク質＝フィブロネクチン・ラミニン",
      "構造タンパク質＝フィブロネクチン・ラミニン／プロテオグリカン／接着性糖タンパク質＝コラーゲン・エラスチン",
      "構造タンパク質＝アクチン・チューブリン／プロテオグリカン／接着性糖タンパク質＝カドヘリン",
      "構造タンパク質＝ケラチン／プロテオグリカン／接着性糖タンパク質＝インテグリン",
    ],
    answer: 0,
    hints: [
      "「強度を出すもの」「水を含んでクッションになるもの」「細胞をつなぎ止めるもの」の3つです。",
      "アクチンやケラチンは細胞の中、インテグリンやカドヘリンは細胞膜のタンパク質です。",
    ],
    solution: `<p><b>【ステップ1】3群と役割</b></p>
               <table>
                 <tr><th>分類</th><th>代表例</th><th>役割</th></tr>
                 <tr><td><b>構造タンパク質</b></td><td><b>コラーゲン、エラスチン</b></td><td>引張強度（コラーゲン）と弾性（エラスチン）</td></tr>
                 <tr><td><b>プロテオグリカン</b></td><td>アグリカン、パールカン</td><td>大量の水を保持しクッションとなる、増殖因子の貯蔵</td></tr>
                 <tr><td><b>接着性糖タンパク質</b></td><td><b>フィブロネクチン、ラミニン</b></td><td>細胞（インテグリン）と ECM をつなぐ</td></tr>
               </table>
               <p><b>【ステップ2】紛らわしいものを切り分ける</b></p>
               <ul>
                 <li><b>細胞内</b>の骨格：アクチン、チューブリン、ケラチン（中間径フィラメント）</li>
                 <li><b>細胞膜</b>の接着分子：インテグリン（ECMと結合）、カドヘリン（細胞同士）</li>
                 <li><b>細胞外</b>：上の表の3群</li>
               </ul>
               <p>「どこにあるか」で仕分けると混同しません。</p>
               <p><b>【ステップ3】基底膜</b></p>
               <p>上皮の下に敷かれた特殊な ECM で、<b>IV型コラーゲン・ラミニン・ニドゲン・パールカン</b>が
               主成分です。フィブロネクチンではなく<b>ラミニン</b>が基底膜の主役である点が問われます。</p>
               <p>したがって、正解は <b>A</b> です。</p>`,
  },

  {
    id: "dyn12", ...CAT,
    title: "プロテオグリカンとグリコサミノグリカン", diff: 240, tags: ["プロテオグリカン", "GAG", "ヒアルロン酸"],
    explain: `<p>プロテオグリカンとグリコサミノグリカン（GAG）について、正しい記述はどれか。</p>`,
    type: "radio",
    options: [
      "GAG はウロン酸とアミノ糖の二糖単位の繰り返しからなり、強い負電荷をもつ。GAG のうちヒアルロン酸だけはコアタンパク質に結合せず、単独で存在する。",
      "GAG はすべてコアタンパク質に共有結合しており、単独で存在するものはない。",
      "GAG は正電荷をもつため、陰イオンを引き寄せて水を保持する。",
      "プロテオグリカンは糖鎖をもたないタンパク質の総称である。",
    ],
    answer: 0,
    hints: [
      "GAG の負電荷はどこから来るでしょうか（カルボキシ基と硫酸基）。",
      "1つだけ例外的な GAG があります。",
    ],
    solution: `<p><b>【ステップ1】GAG の構造</b></p>
               <p>GAG は<b>「ウロン酸 ＋ アミノ糖」の二糖単位が繰り返す</b>直鎖の多糖です。</p>
               <ul>
                 <li>ウロン酸の<b>カルボキシ基</b>と、多くの GAG がもつ<b>硫酸基</b>により<b>強い負電荷</b></li>
                 <li>負電荷どうしが反発して分子が大きく広がり、<b>Na⁺ を引き寄せ、浸透圧で水を大量に保持</b></li>
                 <li>結果として<b>圧縮に耐えるゲル</b>ができる（軟骨が圧に強いのはこのため）</li>
               </ul>
               <p>C は電荷が逆なので誤りです。</p>
               <p><b>【ステップ2】ヒアルロン酸だけが例外</b></p>
               <table>
                 <tr><th></th><th>ヒアルロン酸</th><th>その他のGAG</th></tr>
                 <tr><td>コアタンパク質</td><td><b>結合しない</b>（単独）</td><td>結合する（＝プロテオグリカン）</td></tr>
                 <tr><td>硫酸基</td><td><b>なし</b></td><td>あり</td></tr>
                 <tr><td>合成場所</td><td><b>細胞膜</b>で合成され直接細胞外へ</td><td>ゴルジ体</td></tr>
               </table>
               <p>軟骨では、1本のヒアルロン酸に多数のアグリカンがリンクタンパク質を介して結合し、
               <b>巨大な「ビン洗いブラシ」状の集合体</b>を作ります。</p>
               <p><b>【ステップ3】用語の整理</b></p>
               <p><b>プロテオグリカン ＝ コアタンパク質 ＋ GAG鎖</b>です。
               糖タンパク質（糖鎖が短く分岐する）とは、糖の量・構造ともに異なります。</p>
               <p>したがって、正解は <b>A</b> です。</p>`,
  },

  {
    id: "dyn13", ...CAT,
    title: "4つの接着装置を対応させる", diff: 225, tags: ["接着結合", "デスモソーム", "インテグリン"],
    explain: `<p>接着装置と、そこで働く接着分子・つながる細胞骨格の組み合わせとして<b>誤っている</b>ものはどれか。</p>`,
    type: "radio",
    options: [
      "デスモソーム ─ インテグリン ─ アクチンフィラメント",
      "接着結合 ─ カドヘリン ─ アクチンフィラメント",
      "フォーカルアドヒージョン ─ インテグリン ─ アクチンフィラメント",
      "ヘミデスモソーム ─ インテグリン ─ 中間径フィラメント",
    ],
    answer: 0,
    hints: [
      "細胞どうしをつなぐのはカドヘリン、細胞とECMをつなぐのはインテグリンです。",
      "デスモソームの「ソーム」は中間径フィラメントとセットで覚えます。",
    ],
    solution: `<p><b>【ステップ1】表で覚える</b></p>
               <table>
                 <tr><th>接着装置</th><th>相手</th><th>接着分子</th><th>細胞骨格</th></tr>
                 <tr><td><b>接着結合</b></td><td>細胞－細胞</td><td><b>カドヘリン</b>－カテニン</td><td><b>アクチンフィラメント</b></td></tr>
                 <tr><td><b>デスモソーム</b></td><td>細胞－細胞</td><td><b>カドヘリン</b>（デスモグレイン、デスモコリン）</td><td><b>中間径フィラメント</b>（ケラチン）</td></tr>
                 <tr><td><b>フォーカルアドヒージョン</b></td><td>細胞－ECM</td><td><b>インテグリン</b>－フィブロネクチン</td><td><b>アクチンフィラメント</b></td></tr>
                 <tr><td><b>ヘミデスモソーム</b></td><td>細胞－ECM（基底膜）</td><td><b>インテグリン</b>－ラミニン</td><td><b>中間径フィラメント</b></td></tr>
               </table>
               <p>A はデスモソームなのにインテグリンとアクチンになっており、二重に誤りです。</p>
               <p><b>【ステップ2】覚え方</b></p>
               <ul>
                 <li>相手が<b>細胞</b>なら<b>カドヘリン</b>、相手が<b>ECM</b>なら<b>インテグリン</b></li>
                 <li>名前に<b>「デスモ」</b>が付くものは<b>中間径フィラメント</b></li>
               </ul>
               <p>この2つのルールだけで4行すべて再現できます。
               なお細胞間接着分子カドヘリンは<b>竹市雅俊</b>によって発見され、
               <b>Ca²⁺依存性</b>である点も問われます。</p>
               <p><b>【ステップ3】臨床とのつながり</b></p>
               <p><b>天疱瘡</b>：デスモソームのカドヘリンである<b>デスモグレイン</b>に対する<b>自己抗体</b>ができ、
               表皮の細胞どうしが離れて（棘融解）水疱を生じます。
               一方<b>類天疱瘡</b>はヘミデスモソーム成分（BP180 など）に対する自己抗体で、
               表皮そのものが基底膜から剥がれるため<b>より緊満性の水疱</b>になります。</p>
               <p>したがって、<b>誤っている</b>のは <b>A</b> です。</p>`,
  },

  {
    id: "dyn14", ...CAT,
    title: "密着結合のはたらき", diff: 175, tags: ["密着結合", "極性", "クローディン"],
    explain: `<p>上皮細胞の<b>密着結合（タイトジャンクション）</b>がもつ生理的な役割として、最も適切なものはどれか。</p>`,
    type: "radio",
    options: [
      "細胞間隙を通る物質の移動を制限するとともに、膜タンパク質が頂端側と基底側の間を行き来するのを妨げ、上皮の極性を保つ。",
      "隣り合う細胞の細胞質を直接つなぎ、イオンや小分子を通過させる。",
      "細胞と細胞外マトリックスを結合し、細胞の移動を可能にする。",
      "中間径フィラメントを介して細胞に機械的強度を与える。",
    ],
    answer: 0,
    hints: [
      "「バリア」としての働きと、もうひとつ「柵（フェンス）」としての働きがあります。",
      "B はギャップ結合の説明です。",
    ],
    solution: `<p><b>【ステップ1】2つの機能</b></p>
               <ul>
                 <li><b>バリア機能</b>：<b>クローディン</b>とオクルディンが隣接細胞間で密着し、
                 細胞と細胞の<b>すきま（傍細胞経路）</b>を通る物質の移動を制限する。
                 どのクローディンが並ぶかによって、通すイオンと通さないイオンが決まります。</li>
                 <li><b>フェンス機能</b>：細胞膜の脂質・膜タンパク質が<b>頂端側（apical）と基底側方（basolateral）
                 の間を自由に拡散するのを妨げる</b>。これにより、頂端側と基底側に別々の輸送体を配置でき、
                 <b>物質の一方向輸送</b>が可能になります。</li>
               </ul>
               <p><b>【ステップ2】なぜ極性が要るのか</b></p>
               <p>小腸上皮が管腔側からグルコースを取り込み、血管側へ送り出せるのは、
               頂端側に SGLT1、基底側に GLUT2 と<b>別の輸送体が配置されている</b>からです。
               密着結合がなければ輸送体が混ざってしまい、方向性のある輸送はできません。</p>
               <p><b>【ステップ3】他の結合との対比</b></p>
               <table>
                 <tr><th>結合</th><th>役割</th></tr>
                 <tr><td><b>密着結合</b></td><td>封鎖（バリア＋フェンス）</td></tr>
                 <tr><td>接着結合・デスモソーム</td><td>機械的な接着</td></tr>
                 <tr><td><b>ギャップ結合</b></td><td><b>連絡</b>（コネキシンが作る孔で小分子・イオンを通す）</td></tr>
               </table>
               <p>したがって、正解は <b>A</b> です。</p>`,
  },
];
